import React, { FC } from 'react'
import { Icon } from '@iconify/react'
import S from './Progress.styles'

interface Step {
  id: number
  title: string
}

interface ProgressProps {
  /** The percent complete (0 to 100) */
  value: number
  steps: Step[]
  currentStep: number
}

const Progress: FC<ProgressProps> = ({ value, steps, currentStep }) => {
  const isPast = (step: Step) => step.id < currentStep
  const isCurrent = (step: Step) => step.id === currentStep
  const isFuture = (step: Step) => step.id > currentStep

  return (
    <S.Progress>
      <div>
        {steps.map(s => (
          <S.Step key={s.id}>
            {isPast(s) && (
              <S.PastStep>
                <Icon icon="fe:check" fontSize={24} />
              </S.PastStep>
            )}
            {isCurrent(s) && <S.CurrentStep>{s.id}</S.CurrentStep>}
            {isFuture(s) && <S.FutureStep>{s.id}</S.FutureStep>}
            <p className={isFuture(s) ? 'isFuture' : ''}>{s.title}</p>
          </S.Step>
        ))}
      </div>
      <progress value={value} max={100} />
    </S.Progress>
  )
}

export default Progress
